module.exports = __webpack_public_path__ + "static/media/599.767 (7).4d1a542f.pdf";